import { calcCount } from '@/shared/job/insight.dto';
import { Eye, Users } from 'lucide-react';
import { InsightCardIcon } from './InsightCardIcon';
export function AdViewsCard({
  title,
  totalLabel,
  views,
}: {
  title: string;
  totalLabel: string;
  views: number;
}) {
  const displayViews = views > 0 ? views : 1;

  return (
    <div className="flex h-full flex-col rounded-lg border border-gray-200 bg-white p-4">
      <div className="mb-4 flex items-center gap-2">
        <InsightCardIcon icon={Eye} />
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      </div>
      <div>
        <div className="mb-1 flex items-center gap-1 text-xs text-gray-500">
          <Users className="h-3.5 w-3.5 shrink-0" />
          {totalLabel}
        </div>
        <p className="text-2xl font-medium leading-8 text-primary">
          {calcCount(displayViews)}
        </p>
      </div>
    </div>
  );
}
